module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av361-6232b7fb0f5a3ef70fee008a2cffd608.jpg";